import { authHeader, handleResponse } from "./helper";
import { getCookie } from './cookies';
import config from "../config";

const getReservation = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/reservations/${params.reservationId}`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};
export const triggerOperativeConditionals = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify({
      admissionPatientId: params.admissionPatientId,
    }),
  };
  const url = new URL(
    `${config.apiReservationUrl}/admissions/triggerOperativeConditionals`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};


const getAdmissionServices = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/admissions/${params.reservationId}/admissionSummary`
  );

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getServicesSuggestions = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiReservationUrl}/admissions/${params.reservationId}/servicesSuggestions`);

  if (params.patientId) url.searchParams.append('patient_id', params.patientId);
  if (params.providerCode) url.searchParams.append('provider_code', params.providerCode);

  return await fetch(url, requestOptions).then(handleResponse);
}

const getAdmittedPatients = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/admissions/${params.reservationId}/patients`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getPatient = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/patients`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getServices = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(`${config.apiGeneralUrl}/prestations`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getService = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/prestations/getPrestation`);

  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getLaboratoryPrestations = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/prestations/getLaboratoryPrestations`);

  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getConsents = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(`${config.apiReservationUrl}/admissions/consents`);

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const getPopupConsent = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(
    `${config.apiReservationUrl}/admissions/consents/${params.consentType}`
  );

  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

const sendPatientAndConsents = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiReservationUrl}/admissions/create`);

  return await fetch(url, requestOptions).then(handleResponse);
};

const updatePaymentMethods = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiReservationUrl}/admissions/savePayment`);

  return await fetch(url, requestOptions).then(handleResponse);
};

const loginUserSovos = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiSignerUrl}/signer/login`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const serviceConditions = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiGeneralUrl}/exams/serviceConditions`);

  return await fetch(url, requestOptions).then(handleResponse);
}

export const evaluateConditionals = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiReservationUrl}/admissions/evaluateConditionals`);

  return await fetch(url, requestOptions).then(handleResponse);
}

export const updateCompany = async (params) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiReservationUrl}/admissions/company`);

  return await fetch(url, requestOptions).then(handleResponse);
}


export const admissionService = {
  getReservation,
  getAdmissionServices,
  getAdmittedPatients,
  getPatient,
  getServices,
  getConsents,
  getPopupConsent,
  sendPatientAndConsents,
  updatePaymentMethods,
  getLaboratoryPrestations,
  getService,
  loginUserSovos
};